const Types = {
	REQUEST_LOADING: 'REQUEST_LOADING',
	LIST_UPLOADS_SUCCESS: 'LIST_UPLOADS_SUCCESS',
	LIST_UPLOADS_FAILURE: 'LIST_UPLOADS_FAILURE',
	LIST_FILE_UPLOAD_SUCCESS: 'LIST_FILE_UPLOAD_SUCCESS',
	// news
	GET_ALL_UPLOADS_LOADING: 'GET_ALL_UPLOADS_LOADING',
	GET_ALL_UPLOADS_SUCESS: 'GET_ALL_UPLOADS_SUCESS',
	GET_ALL_UPLOADS_ERROR: 'GET_ALL_UPLOADS_ERROR',

	UPDATE_FILE_SOCKET: 'UPDATE_FILE_SOCKET',

	// Refactor Types
	FIND_AND_FILTER_LOADING: 'FIND_AND_FILTER_LOADING',
	FIND_AND_FILTER_SUCCESS: 'FIND_AND_FILTER_SUCCESS',
	FIND_AND_FILTER_ERROR: 'FIND_AND_FILTER_ERROR',

	LIST_UPLOAD_LOADING: 'LIST_UPLOAD_LOADING',
	LIST_UPLOAD_SUCCESS: 'LIST_UPLOAD_SUCESS',
	LIST_UPLOAD_ERROR: 'LIST_UPLOAD_ERROR',

	UPLOAD_STATUS_FILE: 'UPLOAD_STATUS_FILE'
};

export default Types;
